import { j as f } from "./jsx-runtime-3tyXYecC.mjs";
import * as w from "react";
import { useRef as fe, useEffect as Ge, useLayoutEffect as Se, createContext as gt, isValidElement as Ae, Children as qe, forwardRef as Qe, useContext as Je, useState as J, useCallback as Ye } from "react";
import { f as we } from "./index-LyFokDcn.mjs";
import { u as xt, m as ze, c as yt } from "./tss-DN0acMKN.mjs";
import { B as St } from "./Box-BghdyyLI.mjs";
import { M as L, d as E } from "./constants-CnFYFetN.mjs";
import { l as ye } from "./lodash-5ofSKtz3.mjs";
import "./useFetch-Dpmq0XZr.mjs";
import { D as wt } from "./dropdown-Do4wRJvN.mjs";
import { I as Ze } from "./icon-v2-DGtVEk7e.mjs";
import "./react-is.production.min-CoyJavcO.mjs";
import { g as et, c as ue } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { u as tt } from "./index-CLU0MTzP.mjs";
import { s as pe, u as ot, c as rt } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { m as nt } from "./memoTheme-BzXKG_-k.mjs";
import { u as vt } from "./useEnhancedEffect-CJGo-L3B.mjs";
import { d as it, o as lt } from "./ownerWindow-CJokPycY.mjs";
import { g as at } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { u as Be } from "./useSlotProps-DmbFUW3M.mjs";
import { u as De } from "./useEventCallback-B4gn-DZo.mjs";
import { c as st } from "./createSvgIcon-ButWPptu.mjs";
import { B as Fe } from "./ButtonBase-BIvHZGlt.mjs";
import { o as Tt } from "./ownerDocument-CUrv0DIK.mjs";
import { c as _ } from "./index-DkZ16bcJ.mjs";
import { M as Mt } from "./menu-63UgiRJf.mjs";
const Ct = st(/* @__PURE__ */ f.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), It = st(/* @__PURE__ */ f.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function Bt(t) {
  return (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2;
}
function zt(t, n, e, i = {}, r = () => {
}) {
  const {
    ease: o = Bt,
    duration: c = 300
    // standard
  } = i;
  let l = null;
  const d = n[t];
  let u = !1;
  const m = () => {
    u = !0;
  }, S = (v) => {
    if (u) {
      r(new Error("Animation cancelled"));
      return;
    }
    l === null && (l = v);
    const b = Math.min(1, (v - l) / c);
    if (n[t] = o(b) * (e - d) + d, b >= 1) {
      requestAnimationFrame(() => {
        r(null);
      });
      return;
    }
    requestAnimationFrame(S);
  };
  return d === e ? (r(new Error("Element already at target position")), m) : (requestAnimationFrame(S), m);
}
const Rt = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function Lt(t) {
  const {
    onChange: n,
    ...e
  } = t, i = w.useRef(), r = w.useRef(null), o = () => {
    i.current = r.current.offsetHeight - r.current.clientHeight;
  };
  return vt(() => {
    const c = it(() => {
      const d = i.current;
      o(), d !== i.current && n(i.current);
    }), l = lt(r.current);
    return l.addEventListener("resize", c), () => {
      c.clear(), l.removeEventListener("resize", c);
    };
  }, [n]), w.useEffect(() => {
    o(), n(i.current);
  }, [n]), /* @__PURE__ */ f.jsx("div", {
    style: Rt,
    ref: r,
    ...e
  });
}
function Et(t) {
  return et("MuiTabScrollButton", t);
}
const $t = at("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), kt = (t) => {
  const {
    classes: n,
    orientation: e,
    disabled: i
  } = t;
  return rt({
    root: ["root", e, i && "disabled"]
  }, Et, n);
}, Wt = pe(Fe, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (t, n) => {
    const {
      ownerState: e
    } = t;
    return [n.root, e.orientation && n[e.orientation]];
  }
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${$t.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
}), Dt = /* @__PURE__ */ w.forwardRef(function(n, e) {
  const i = ot({
    props: n,
    name: "MuiTabScrollButton"
  }), {
    className: r,
    slots: o = {},
    slotProps: c = {},
    direction: l,
    orientation: d,
    disabled: u,
    ...m
  } = i, S = tt(), v = {
    isRtl: S,
    ...i
  }, b = kt(v), k = o.StartScrollButtonIcon ?? Ct, B = o.EndScrollButtonIcon ?? It, M = Be({
    elementType: k,
    externalSlotProps: c.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: v
  }), p = Be({
    elementType: B,
    externalSlotProps: c.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: v
  });
  return /* @__PURE__ */ f.jsx(Wt, {
    component: "div",
    className: ue(b.root, r),
    ref: e,
    role: null,
    ownerState: v,
    tabIndex: null,
    ...m,
    style: {
      ...m.style,
      ...d === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${S ? -90 : 90}deg)`
      }
    },
    children: l === "left" ? /* @__PURE__ */ f.jsx(k, {
      ...M
    }) : /* @__PURE__ */ f.jsx(B, {
      ...p
    })
  });
});
function jt(t) {
  return et("MuiTabs", t);
}
const je = at("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), _e = (t, n) => t === n ? t.firstChild : n && n.nextElementSibling ? n.nextElementSibling : t.firstChild, Ke = (t, n) => t === n ? t.lastChild : n && n.previousElementSibling ? n.previousElementSibling : t.lastChild, Ie = (t, n, e) => {
  let i = !1, r = e(t, n);
  for (; r; ) {
    if (r === t.firstChild) {
      if (i)
        return;
      i = !0;
    }
    const o = r.disabled || r.getAttribute("aria-disabled") === "true";
    if (!r.hasAttribute("tabindex") || o)
      r = e(t, r);
    else {
      r.focus();
      return;
    }
  }
}, Ft = (t) => {
  const {
    vertical: n,
    fixed: e,
    hideScrollbar: i,
    scrollableX: r,
    scrollableY: o,
    centered: c,
    scrollButtonsHideMobile: l,
    classes: d
  } = t;
  return rt({
    root: ["root", n && "vertical"],
    scroller: ["scroller", e && "fixed", i && "hideScrollbar", r && "scrollableX", o && "scrollableY"],
    flexContainer: ["flexContainer", n && "flexContainerVertical", c && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", l && "scrollButtonsHideMobile"],
    scrollableX: [r && "scrollableX"],
    hideScrollbar: [i && "hideScrollbar"]
  }, jt, d);
}, At = pe("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (t, n) => {
    const {
      ownerState: e
    } = t;
    return [{
      [`& .${je.scrollButtons}`]: n.scrollButtons
    }, {
      [`& .${je.scrollButtons}`]: e.scrollButtonsHideMobile && n.scrollButtonsHideMobile
    }, n.root, e.vertical && n.vertical];
  }
})(nt(({
  theme: t
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: ({
      ownerState: n
    }) => n.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: n
    }) => n.scrollButtonsHideMobile,
    style: {
      [`& .${je.scrollButtons}`]: {
        [t.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
}))), Ht = pe("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (t, n) => {
    const {
      ownerState: e
    } = t;
    return [n.scroller, e.fixed && n.fixed, e.hideScrollbar && n.hideScrollbar, e.scrollableX && n.scrollableX, e.scrollableY && n.scrollableY];
  }
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: ({
      ownerState: t
    }) => t.fixed,
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hideScrollbar,
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.scrollableX,
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.scrollableY,
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
}), Pt = pe("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (t, n) => {
    const {
      ownerState: e
    } = t;
    return [n.flexContainer, e.vertical && n.flexContainerVertical, e.centered && n.centered];
  }
})({
  display: "flex",
  variants: [{
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.centered,
    style: {
      justifyContent: "center"
    }
  }]
}), Nt = pe("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (t, n) => n.indicator
})(nt(({
  theme: t
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: t.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (t.vars || t).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (t.vars || t).palette.secondary.main
    }
  }, {
    props: ({
      ownerState: n
    }) => n.vertical,
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
}))), Ot = pe(Lt)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), Ue = {}, ct = /* @__PURE__ */ w.forwardRef(function(n, e) {
  const i = ot({
    props: n,
    name: "MuiTabs"
  }), r = xt(), o = tt(), {
    "aria-label": c,
    "aria-labelledby": l,
    action: d,
    centered: u = !1,
    children: m,
    className: S,
    component: v = "div",
    allowScrollButtonsMobile: b = !1,
    indicatorColor: k = "primary",
    onChange: B,
    orientation: M = "horizontal",
    ScrollButtonComponent: p = Dt,
    scrollButtons: C = "auto",
    selectionFollowsFocus: W,
    slots: D = {},
    slotProps: j = {},
    TabIndicatorProps: F = {},
    TabScrollButtonProps: H = {},
    textColor: P = "primary",
    value: G,
    variant: O = "standard",
    visibleScrollbar: h = !1,
    ...V
  } = i, I = O === "scrollable", N = M === "vertical", ee = N ? "scrollTop" : "scrollLeft", ie = N ? "top" : "left", le = N ? "bottom" : "right", te = N ? "clientHeight" : "clientWidth", oe = N ? "height" : "width", q = {
    ...i,
    component: v,
    allowScrollButtonsMobile: b,
    indicatorColor: k,
    orientation: M,
    vertical: N,
    scrollButtons: C,
    textColor: P,
    variant: O,
    visibleScrollbar: h,
    fixed: !I,
    hideScrollbar: I && !h,
    scrollableX: I && !N,
    scrollableY: I && N,
    centered: u && !I,
    scrollButtonsHideMobile: !b
  }, K = Ft(q), Re = Be({
    elementType: D.StartScrollButtonIcon,
    externalSlotProps: j.startScrollButtonIcon,
    ownerState: q
  }), ae = Be({
    elementType: D.EndScrollButtonIcon,
    externalSlotProps: j.endScrollButtonIcon,
    ownerState: q
  }), [ve, Te] = w.useState(!1), [A, Z] = w.useState(Ue), [se, Le] = w.useState(!1), [ce, Ee] = w.useState(!1), [me, $e] = w.useState(!1), [be, de] = w.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), he = /* @__PURE__ */ new Map(), X = w.useRef(null), g = w.useRef(null), z = () => {
    const a = X.current;
    let s;
    if (a) {
      const x = a.getBoundingClientRect();
      s = {
        clientWidth: a.clientWidth,
        scrollLeft: a.scrollLeft,
        scrollTop: a.scrollTop,
        scrollWidth: a.scrollWidth,
        top: x.top,
        bottom: x.bottom,
        left: x.left,
        right: x.right
      };
    }
    let y;
    if (a && G !== !1) {
      const x = g.current.children;
      if (x.length > 0) {
        const T = x[he.get(G)];
        y = T ? T.getBoundingClientRect() : null;
      }
    }
    return {
      tabsMeta: s,
      tabMeta: y
    };
  }, R = De(() => {
    const {
      tabsMeta: a,
      tabMeta: s
    } = z();
    let y = 0, x;
    N ? (x = "top", s && a && (y = s.top - a.top + a.scrollTop)) : (x = o ? "right" : "left", s && a && (y = (o ? -1 : 1) * (s[x] - a[x] + a.scrollLeft)));
    const T = {
      [x]: y,
      // May be wrong until the font is loaded.
      [oe]: s ? s[oe] : 0
    };
    if (typeof A[x] != "number" || typeof A[oe] != "number")
      Z(T);
    else {
      const U = Math.abs(A[x] - T[x]), ne = Math.abs(A[oe] - T[oe]);
      (U >= 1 || ne >= 1) && Z(T);
    }
  }), Y = (a, {
    animation: s = !0
  } = {}) => {
    s ? zt(ee, X.current, a, {
      duration: r.transitions.duration.standard
    }) : X.current[ee] = a;
  }, re = (a) => {
    let s = X.current[ee];
    N ? s += a : s += a * (o ? -1 : 1), Y(s);
  }, Q = () => {
    const a = X.current[te];
    let s = 0;
    const y = Array.from(g.current.children);
    for (let x = 0; x < y.length; x += 1) {
      const T = y[x];
      if (s + T[te] > a) {
        x === 0 && (s = a);
        break;
      }
      s += T[te];
    }
    return s;
  }, ge = () => {
    re(-1 * Q());
  }, Ne = () => {
    re(Q());
  }, pt = w.useCallback((a) => {
    de({
      overflow: null,
      scrollbarWidth: a
    });
  }, []), mt = () => {
    const a = {};
    a.scrollbarSizeListener = I ? /* @__PURE__ */ f.jsx(Ot, {
      onChange: pt,
      className: ue(K.scrollableX, K.hideScrollbar)
    }) : null;
    const y = I && (C === "auto" && (se || ce) || C === !0);
    return a.scrollButtonStart = y ? /* @__PURE__ */ f.jsx(p, {
      slots: {
        StartScrollButtonIcon: D.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: Re
      },
      orientation: M,
      direction: o ? "right" : "left",
      onClick: ge,
      disabled: !se,
      ...H,
      className: ue(K.scrollButtons, H.className)
    }) : null, a.scrollButtonEnd = y ? /* @__PURE__ */ f.jsx(p, {
      slots: {
        EndScrollButtonIcon: D.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: ae
      },
      orientation: M,
      direction: o ? "left" : "right",
      onClick: Ne,
      disabled: !ce,
      ...H,
      className: ue(K.scrollButtons, H.className)
    }) : null, a;
  }, Oe = De((a) => {
    const {
      tabsMeta: s,
      tabMeta: y
    } = z();
    if (!(!y || !s)) {
      if (y[ie] < s[ie]) {
        const x = s[ee] + (y[ie] - s[ie]);
        Y(x, {
          animation: a
        });
      } else if (y[le] > s[le]) {
        const x = s[ee] + (y[le] - s[le]);
        Y(x, {
          animation: a
        });
      }
    }
  }), Me = De(() => {
    I && C !== !1 && $e(!me);
  });
  w.useEffect(() => {
    const a = it(() => {
      X.current && R();
    });
    let s;
    const y = (U) => {
      U.forEach((ne) => {
        ne.removedNodes.forEach((xe) => {
          s == null || s.unobserve(xe);
        }), ne.addedNodes.forEach((xe) => {
          s == null || s.observe(xe);
        });
      }), a(), Me();
    }, x = lt(X.current);
    x.addEventListener("resize", a);
    let T;
    return typeof ResizeObserver < "u" && (s = new ResizeObserver(a), Array.from(g.current.children).forEach((U) => {
      s.observe(U);
    })), typeof MutationObserver < "u" && (T = new MutationObserver(y), T.observe(g.current, {
      childList: !0
    })), () => {
      a.clear(), x.removeEventListener("resize", a), T == null || T.disconnect(), s == null || s.disconnect();
    };
  }, [R, Me]), w.useEffect(() => {
    const a = Array.from(g.current.children), s = a.length;
    if (typeof IntersectionObserver < "u" && s > 0 && I && C !== !1) {
      const y = a[0], x = a[s - 1], T = {
        root: X.current,
        threshold: 0.99
      }, U = (We) => {
        Le(!We[0].isIntersecting);
      }, ne = new IntersectionObserver(U, T);
      ne.observe(y);
      const xe = (We) => {
        Ee(!We[0].isIntersecting);
      }, Xe = new IntersectionObserver(xe, T);
      return Xe.observe(x), () => {
        ne.disconnect(), Xe.disconnect();
      };
    }
  }, [I, C, me, m == null ? void 0 : m.length]), w.useEffect(() => {
    Te(!0);
  }, []), w.useEffect(() => {
    R();
  }), w.useEffect(() => {
    Oe(Ue !== A);
  }, [Oe, A]), w.useImperativeHandle(d, () => ({
    updateIndicator: R,
    updateScrollButtons: Me
  }), [R, Me]);
  const Ve = /* @__PURE__ */ f.jsx(Nt, {
    ...F,
    className: ue(K.indicator, F.className),
    ownerState: q,
    style: {
      ...A,
      ...F.style
    }
  });
  let Ce = 0;
  const bt = w.Children.map(m, (a) => {
    if (!/* @__PURE__ */ w.isValidElement(a))
      return null;
    const s = a.props.value === void 0 ? Ce : a.props.value;
    he.set(s, Ce);
    const y = s === G;
    return Ce += 1, /* @__PURE__ */ w.cloneElement(a, {
      fullWidth: O === "fullWidth",
      indicator: y && !ve && Ve,
      selected: y,
      selectionFollowsFocus: W,
      onChange: B,
      textColor: P,
      value: s,
      ...Ce === 1 && G === !1 && !a.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  }), ht = (a) => {
    const s = g.current, y = Tt(s).activeElement;
    if (y.getAttribute("role") !== "tab")
      return;
    let T = M === "horizontal" ? "ArrowLeft" : "ArrowUp", U = M === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (M === "horizontal" && o && (T = "ArrowRight", U = "ArrowLeft"), a.key) {
      case T:
        a.preventDefault(), Ie(s, y, Ke);
        break;
      case U:
        a.preventDefault(), Ie(s, y, _e);
        break;
      case "Home":
        a.preventDefault(), Ie(s, null, _e);
        break;
      case "End":
        a.preventDefault(), Ie(s, null, Ke);
        break;
    }
  }, ke = mt();
  return /* @__PURE__ */ f.jsxs(At, {
    className: ue(K.root, S),
    ownerState: q,
    ref: e,
    as: v,
    ...V,
    children: [ke.scrollButtonStart, ke.scrollbarSizeListener, /* @__PURE__ */ f.jsxs(Ht, {
      className: K.scroller,
      ownerState: q,
      style: {
        overflow: be.overflow,
        [N ? `margin${o ? "Left" : "Right"}` : "marginBottom"]: h ? void 0 : -be.scrollbarWidth
      },
      ref: X,
      children: [/* @__PURE__ */ f.jsx(Pt, {
        "aria-label": c,
        "aria-labelledby": l,
        "aria-orientation": M === "vertical" ? "vertical" : null,
        className: K.flexContainer,
        ownerState: q,
        onKeyDown: ht,
        ref: g,
        role: "tablist",
        children: bt
      }), ve && Ve]
    }), ke.scrollButtonEnd]
  });
});
function Vt(t, n, e, i) {
  const r = fe(n);
  Xt(() => {
    r.current = n;
  }, [n]), Ge(() => {
    var o;
    const c = (o = void 0) !== null && o !== void 0 ? o : window;
    if (!(c && c.addEventListener))
      return;
    const l = (d) => r.current(d);
    return c.addEventListener(t, l, i), () => {
      c.removeEventListener(t, l, i);
    };
  }, [t, e, i]);
}
const Xt = typeof window < "u" ? Se : Ge, Yt = ze({ name: "MuiTab" })((t, n, e) => {
  const {
    typography: i,
    breakpoints: r,
    palette: o,
    spacing: c,
    mixins: { alpha: l },
    mode: d,
    transitions: u
  } = t;
  return we.ifFeature(
    "encore",
    {
      root: {
        boxSizing: "border-box",
        color: o.gray[800],
        fill: o.gray[800],
        maxWidth: 264,
        minWidth: 72,
        position: "relative",
        flexShrink: 0,
        fontSize: i.button.fontSize,
        fontWeight: i.button.fontWeight,
        lineHeight: i.button.lineHeight,
        overflow: "hidden",
        textAlign: "left",
        transition: u.create(["color", "fill"]),
        whiteSpace: "normal",
        // override MUI specificity
        "&&": {
          padding: c(0, 1.5, 2),
          [`&.${e.sizeLarge}`]: {
            padding: c(0, 2, 2.5)
          },
          [`&.${e.modeFill}`]: {
            padding: c(2)
          },
          [`&.${e.modeFill}.${e.sizeLarge}`]: {
            padding: c(2.5, 3)
          }
        },
        "&:hover, &:focus-visible": {
          color: o.primary.main,
          fill: o.primary.main,
          textDecoration: "none"
        }
      },
      dark: {
        color: o.common.white,
        fill: o.common.white,
        [`&.${e.disabled}`]: {
          color: l(o.common.white, 0.6),
          fill: l(o.common.white, 0.6)
        },
        [`&:not(.${e.selected}):not(.${e.disabled})`]: {
          color: o.common.white,
          fill: o.common.white,
          "&:hover, &:focus-visible": {
            backgroundColor: l(o.common.white, 0.1),
            color: o.common.white,
            fill: o.common.white
          }
        }
      },
      description: {
        color: o.gray[700],
        display: "none",
        fontSize: i.small.fontSize,
        fontWeight: i.fontWeightRegular,
        lineHeight: i.small.lineHeight,
        gridArea: "description",
        [`.${e.modeFill}.${e.sizeLarge} &`]: {
          display: "unset"
        },
        [`.${e.dark} &, .${e.disabled} &`]: {
          color: "inherit"
        }
      },
      disabled: {
        color: o.gray[600],
        fill: o.gray[600]
      },
      dropdownIcon: {
        alignItems: "center",
        display: "inline-flex",
        gridArea: "dropdownIcon",
        height: 16,
        width: 16
      },
      fixedDropdown: {
        marginLeft: "auto"
      },
      fullWidth: {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none",
        minWidth: "min-content"
      },
      icon: {
        gridArea: "icon",
        "& > svg": {
          display: "block"
        }
      },
      isDropdown: {
        [`&.${e.disabled}`]: {
          cursor: "auto",
          pointerEvents: "auto"
        }
      },
      label: {
        // retained from Jade to make transition to Encore easier
        display: "inline-flex",
        color: d === L.Dye ? E.light : void 0,
        flexDirection: "column",
        "&:after": {
          content: "attr(data-text)",
          height: 0,
          visibility: "hidden",
          overflow: "hidden",
          userSelect: "none",
          pointerEvents: "none",
          fontWeight: 700
        },
        fontSize: i.large.fontSize,
        lineHeight: i.large.lineHeight,
        gridArea: "label",
        [`.${e.modeFill} &`]: {
          fontSize: i.medium.fontSize,
          lineHeight: i.medium.lineHeight
        },
        [`.${e.sizeLarge} &`]: {
          fontSize: i.h5.fontSize,
          lineHeight: i.h5.lineHeight
        },
        [`.${e.modeFill}.${e.sizeLarge} &`]: {
          fontSize: i.large.fontSize,
          lineHeight: i.large.lineHeight
        },
        [`.${e.dark}.${e.disabled} &`]: {
          color: l(o.common.white, 0.6)
        }
      },
      modeLine: {
        "&:hover:after, &:focus-visible:after": {
          background: o.gray[600],
          borderRadius: 4,
          bottom: 0,
          content: '""',
          display: "block",
          height: 3,
          position: "absolute",
          width: "100%"
        }
      },
      modeFill: {
        borderTopLeftRadius: 9,
        borderTopRightRadius: 9,
        padding: c(2),
        [`&.${e.selected}`]: {
          backgroundColor: o.gray[50],
          boxShadow: "none"
        },
        [`&.${e.sizeLarge}`]: {
          padding: c(2.5, 3)
        },
        [`&:hover:not(.${e.selected}), &:focus-visible:not(.${e.selected})`]: {
          backgroundColor: l(o.gray[50], 0.9)
        }
      },
      selected: {
        color: o.primary.main,
        fill: o.primary.main,
        fontWeight: 700
      },
      sizeLarge: {
        maxWidth: 296,
        // retained from Jade to make transition to Encore easier
        [`& .${e.wrapper} .${e.label} .MuiTypography-caption`]: {
          color: o.gray[700]
        }
      },
      wrapper: {
        alignItems: "center",
        // using grid because the label needs to be centered with the icon AND the description needs to align with the label
        display: "grid",
        gridTemplateAreas: `
					"icon label       dropdownIcon"
					".    description .           "
				`,
        // would prefer to use column-gap here, but it inserts a gap between every column, even if those columns are empty
        // thus, even if we only have an icon, there would be a gap for label and dropdown icon as well
        [`& .${e.icon} + .${e.label}, .${e.dropdownIcon}, .${e.description}`]: {
          marginLeft: 12
        },
        [`&:has(.${e.description})`]: {
          gridRowGap: c(0.25)
        }
      },
      labelIcon: {},
      textColorInherit: {},
      textColorPrimary: {},
      textColorSecondary: {},
      wrapped: {}
    },
    {
      root: {
        fontSize: i.button.fontSize,
        fontWeight: i.button.fontWeight,
        lineHeight: i.button.lineHeight,
        maxWidth: 264,
        minWidth: 72,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "6px 12px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center",
        "&:hover": {
          color: o.primary.main,
          fill: o.primary.main,
          textDecoration: "none"
        }
      },
      labelIcon: {
        fill: d === L.Dye ? E.lighter : void 0,
        [`& .${e.wrapper}`]: {
          "& > svg": {
            height: 14,
            width: 14
          }
        },
        [`& .${e.wrapper} > *:first-child`]: {
          marginRight: 8
        }
      },
      textColorInherit: {
        color: "inherit",
        opacity: 0.7,
        [`&.${e.selected}`]: {
          opacity: 1
        },
        [`&.${e.disabled}`]: {
          opacity: o.action.disabledOpacity
        }
      },
      textColorPrimary: {
        color: d === L.Dye ? E.main : o.text.secondary,
        [`&.${e.selected}`]: {
          color: o.primary.main
        },
        [`&.${e.disabled}`]: {
          color: o.text.disabled
        }
      },
      textColorSecondary: {
        color: d === L.Dye ? E.lighter : o.text.secondary,
        fill: d === L.Dye ? E.lighter : void 0,
        [`&.${e.selected}`]: {
          color: o.primary.main,
          fill: o.primary.main,
          fontWeight: 700
        },
        [`&.${e.disabled}`]: {
          color: o.text.disabled,
          fill: o.text.disabled
        },
        opacity: "unset"
      },
      selected: {},
      disabled: {},
      fullWidth: {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
      },
      wrapped: {
        fontSize: i.pxToRem(12),
        lineHeight: 1.5
      },
      wrapper: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        flexDirection: "row",
        margin: c(1.375, 2)
      },
      label: {
        display: "inline-flex",
        color: d === L.Dye ? E.light : void 0,
        flexDirection: "column",
        "&:after": {
          content: "attr(data-text)",
          height: 0,
          visibility: "hidden",
          overflow: "hidden",
          userSelect: "none",
          pointerEvents: "none",
          fontWeight: 700
        }
      },
      dark: {},
      description: {},
      dropdownIcon: {},
      fixedDropdown: {},
      icon: {},
      isDropdown: {},
      modeFill: {},
      modeLine: {},
      sizeLarge: {}
    }
  );
}), He = gt({}), _t = (t, n, e, i) => {
  let r = 0, o, c;
  const l = ye.last(e) || 0;
  return t < n && (c = e == null ? void 0 : e.slice(0, -1).some((d, u) => {
    r += d + i, o = u;
    const m = u < e.length - 2 && r + l > t;
    return !!(r > t || m);
  })), c ? o : void 0;
}, Pe = (t) => {
  if (typeof t == "string") return t;
  if (Ae(t)) {
    const n = t, { children: e } = n.props;
    if (e) {
      const i = qe.map(e, (r) => Pe(r));
      return (i == null ? void 0 : i.join(" ")) ?? "";
    }
  }
  return "";
};
function dt(t, n) {
  const e = n === "medium" ? 20 : 24;
  return typeof t == "string" ? (
    // Ensure there is no layout shift while the icon is loading. Probably better to do this in `IconV2` directly, but that needs some more discussion.
    /* @__PURE__ */ f.jsx("div", { style: { height: e, width: e }, children: /* @__PURE__ */ f.jsx(Ze, { name: t, size: e }) })
  ) : t;
}
const ut = Qe(
  ({
    classes: t = {},
    className: n,
    description: e,
    disabled: i = !1,
    fullWidth: r = !1,
    icon: o,
    indicator: c,
    isDropdown: l,
    label: d,
    onChange: u,
    onClick: m,
    onFocus: S,
    overflowProps: v,
    // do not forward to ButtonBase
    selected: b = !1,
    selectionFollowsFocus: k,
    tabPanelId: B,
    textColor: M = "secondary",
    value: p,
    wrapped: C = !1,
    ...W
  }, D) => {
    const j = (I) => {
      !b && u && u(I, p), m && m(I);
    }, F = (I) => {
      k && !b && u && u(I, p), S && S(I);
    }, { dark: H, mode: P, size: G } = Je(He), O = typeof d == "string" ? d : "", { classes: h } = Yt(void 0, { props: { classes: t } }), V = {
      disabled: _("Mui-disabled", h.disabled),
      label: _("MuiTab-label", h.label),
      labelIcon: _("MuiTab-labelIcon", h.labelIcon),
      root: _("MuiTab-root", h.root),
      selected: _("Mui-selected", h.selected),
      textColorInherit: _("MuiTab-textColorInherit", h.textColorInherit),
      textColorPrimary: _("MuiTab-textColorPrimary", h.textColorPrimary),
      textColorSecondary: _("MuiTab-textColorSecondary", h.textColorSecondary),
      wrapper: _("MuiTab-wrapper", h.wrapper)
    };
    return we.ifFeature(
      "encore",
      /* @__PURE__ */ f.jsxs(
        Fe,
        {
          "aria-controls": B,
          "aria-selected": b,
          className: _(
            h.root,
            {
              [h.disabled]: i,
              [h.selected]: b,
              [h.isDropdown]: l,
              [h.fullWidth]: r,
              [h.wrapped]: C,
              [h.dark]: H,
              [h.modeFill]: P === "fill",
              [h.modeLine]: P === "line",
              [h.sizeLarge]: G === "large"
            },
            n
          ),
          disabled: i,
          focusRipple: !0,
          id: `tab-${p}`,
          onClick: j,
          onFocus: F,
          ref: D,
          role: "tab",
          tabIndex: b ? 0 : -1,
          ...W,
          "data-fabric-component": W["data-fabric-component"],
          children: [
            /* @__PURE__ */ f.jsxs("span", { className: h.wrapper, children: [
              o ? /* @__PURE__ */ f.jsx("span", { className: h.icon, children: dt(o, G) }) : null,
              d ? /* @__PURE__ */ f.jsx("span", { className: h.label, "data-text": O, children: d }) : null,
              l ? /* @__PURE__ */ f.jsx("span", { className: h.dropdownIcon, children: /* @__PURE__ */ f.jsx(Ze, { name: "caret-down-solid", size: 16 }) }) : null,
              e ? /* @__PURE__ */ f.jsx("span", { className: h.description, children: e }) : null
            ] }),
            c
          ]
        }
      ),
      /* @__PURE__ */ f.jsxs(
        Fe,
        {
          "aria-controls": B,
          "aria-selected": b,
          className: _(
            V.root,
            V[`textColor${yt(M)}`],
            {
              [V.disabled]: i,
              [V.selected]: b,
              [V.labelIcon]: d && o,
              [h.fullWidth]: r,
              [h.wrapped]: C
            },
            n
          ),
          "data-fabric-component": W["data-fabric-component"],
          disabled: i,
          focusRipple: !0,
          id: `tab-${p}`,
          onClick: j,
          onFocus: F,
          ref: D,
          role: "tab",
          tabIndex: b ? 0 : -1,
          ...W,
          children: [
            /* @__PURE__ */ f.jsxs("span", { className: V.wrapper, children: [
              o,
              /* @__PURE__ */ f.jsx("span", { className: V.label, "data-text": O, children: d })
            ] }),
            c
          ]
        }
      )
    );
  }
), Mo = Qe((t, n) => /* @__PURE__ */ f.jsx(ut, { ...t, "data-fabric-component": "Tab", ref: n })), Kt = ze()((t, n) => {
  const { palette: e } = t, { mode: i } = n;
  return {
    root: i === "fill" ? {
      backgroundColor: e.gray[50],
      borderRadius: 8
    } : {}
  };
}), Co = ({ mode: t, value: n, selectedValue: e, tabPanelId: i, children: r, ...o }) => {
  const { classes: c } = Kt({ mode: t });
  return /* @__PURE__ */ f.jsx(
    St,
    {
      "aria-labelledby": `tab-${n}`,
      className: we.ifFeature("encore", c.root),
      hidden: n !== e,
      id: i,
      role: "tabpanel",
      tabIndex: 0,
      ...o,
      "data-fabric-component": "TabPanel",
      children: r
    }
  );
}, ft = ze({ name: "MuiTabs" })((t, n, e) => {
  const {
    transitions: i,
    palette: r,
    mode: o,
    shadows: c,
    spacing: l,
    mixins: { alpha: d, border: u }
  } = t;
  return we.ifFeature(
    "encore",
    {
      root: {
        // MUI has min-height: 48. Not sure why, so to be safe, using a high number that doesn't break our design.
        minHeight: 40,
        position: "relative",
        outline: o === L.Dye ? `2px solid ${E.main}` : void 0,
        "& .MuiTabs-flexContainer": {
          alignItems: "stretch",
          gap: l(2),
          height: "100%"
        },
        "& .MuiTabs-indicator": {
          borderRadius: 4,
          height: 3
        }
      },
      modeFill: {
        paddingLeft: l(4),
        paddingRight: l(4),
        "& .MuiTabs-flexContainer": {
          gap: l(0.5)
        },
        "& .MuiTabs-indicator": {
          display: "none"
        }
      },
      modeLine: {
        "&:before": {
          backgroundColor: r.gray[300],
          bottom: 0,
          content: '""',
          height: 1,
          position: "absolute",
          width: "100%"
        },
        "&:has(.MuiTabScrollButton-root):before": {
          left: 40,
          right: 40,
          width: "unset"
        }
      },
      sizeLarge: {
        maxHeight: "unset",
        [`&:not(.${e.modeFill}) .MuiTabs-flexContainer`]: {
          gap: l(2.5)
        }
      },
      contained: {},
      darkContained: {},
      darkStandard: {},
      labelSizeLarge: {},
      rootContained: {},
      rootWithDropdown: {},
      rootWithFixedDropdown: {},
      sizeCompact: {},
      standard: {}
    },
    {
      root: {
        maxHeight: 56,
        position: "relative",
        outline: o === L.Dye ? `2px solid ${E.main}` : void 0,
        "& .MuiTab-root": {
          transition: i.create(["color", "fill"])
        },
        "& .MuiTabs-flexContainer": {
          padding: l(1, 0, 0, 0)
        },
        "& .Mui-focusVisible": {
          borderBottom: u(2, r.gray[500]),
          "& .MuiTab-wrapper": {
            marginBottom: 9
          }
        },
        "& .MuiTab-textColorSecondary": {
          "&.Mui-selected": {
            color: o === L.Dye ? E.main : r.primary.main,
            fill: o === L.Dye ? E.main : r.primary.main
          }
        },
        "& .MuiTab-textColorSecondary.Mui-disabled": {
          color: o === L.Dye ? E.lighter : r.text.disabled,
          fill: o === L.Dye ? E.lighter : r.text.disabled
        },
        "& .MuiBox-root button": {
          color: r.gray[800]
        }
      },
      rootWithDropdown: {
        "& .MuiTabs-flexContainer": {
          alignItems: "center"
        }
      },
      rootWithFixedDropdown: {
        "& .MuiTabs-flexContainer": {
          alignItems: "center",
          "& div:last-child": {
            marginLeft: "auto"
          }
        }
      },
      rootContained: {
        maxHeight: 58,
        "&:after": {
          content: '""',
          height: 0,
          width: "100%",
          position: "absolute",
          bottom: 0,
          boxShadow: "0px 4px 5px 0px rgba(0,0,0,0.2), 0px 4px 6px 4px rgba(0,0,0,0.14)"
        },
        "& .MuiTab-labelIcon": {
          "& .MuiTab-wrapper > svg": {
            width: 18,
            height: 18
          }
        },
        "&&": {
          "& .MuiTabs-flexContainer": {
            padding: l(1, 1, 0, 1)
          }
        }
      },
      standard: {
        paddingLeft: l(2.5)
      },
      contained: {
        "& .Mui-focusVisible": {
          border: u(1, r.gray[500]),
          "& .MuiTab-wrapper": {
            margin: "10px 15px"
          }
        },
        "& .MuiTab-textColorSecondary": {
          "&.Mui-selected": {
            transition: i.create("box-shadow", { easing: "easeIn", duration: "short" }),
            backgroundColor: r.common.white,
            boxShadow: c[4],
            zIndex: 1
          }
        },
        "& .MuiTab-root": {
          borderRadius: l(0.5, 0.5, 0, 0),
          "&:hover": {
            backgroundColor: r.common.white,
            zIndex: 1
          }
        },
        "& .MuiTabs-indicator": {
          display: "none"
        }
      },
      darkContained: {
        color: r.common.white,
        fill: r.common.white,
        "& .MuiTab-textColorSecondary": {
          color: r.common.white,
          fill: r.common.white,
          "& .MuiTab-label .MuiTypography-root.MuiTypography-caption": {
            color: "inherit"
          },
          "&.Mui-selected": {
            backgroundColor: r.common.white,
            color: r.primary.main,
            fill: r.primary.main
          }
        },
        "& .MuiTab-root": {
          "&:hover": {
            backgroundColor: d(r.common.white, 0.2),
            color: r.common.white,
            fill: r.common.white
          }
        },
        "& .MuiTab-textColorSecondary.Mui-disabled": {
          color: d(r.common.white, 0.5),
          fill: d(r.common.white, 0.5)
        },
        "& .MuiBox-root": {
          "& button": {
            color: r.common.white
          },
          "& svg": {
            fill: r.common.white
          }
        }
      },
      sizeCompact: {
        "& .MuiTab-root": {
          minWidth: 46
        },
        "& .MuiTab-wrapper": {
          margin: 0,
          "& svg": {
            width: 21,
            height: 21
          }
        },
        "& .Mui-focusVisible": {
          borderBottom: u(2, r.gray[500]),
          "& .MuiTab-wrapper": {
            marginBottom: 0,
            marginTop: 2
          }
        }
      },
      darkStandard: {
        "&&": {
          "& .MuiTab-root": {
            "&:hover": {
              color: r.common.white,
              fill: r.common.white
            }
          },
          "& .MuiTab-textColorSecondary": {
            color: o === L.Dye ? E.lighter : r.gray[400],
            fill: o === L.Dye ? E.lighter : r.gray[500],
            "&.Mui-selected": {
              color: o === L.Dye ? E.main : r.common.white,
              fill: o === L.Dye ? E.main : r.common.white
            }
          },
          "& .MuiTab-textColorSecondary.Mui-disabled": {
            color: d(r.gray[400], 0.2),
            fill: d(r.gray[500], 0.2)
          },
          "& .MuiTabs-indicator": {
            backgroundColor: r.common.white
          },
          "& .MuiTabScrollButton-root": {
            color: r.gray[400]
          },
          "& .MuiBox-root": {
            "& button": {
              color: r.gray[400]
            },
            "& svg": {
              fill: r.gray[400]
            }
          }
        }
      },
      sizeLarge: {
        "&&": {
          maxHeight: "unset"
        },
        "& .MuiTab-root": {
          alignItems: "flex-start",
          maxWidth: 296
        },
        "& .MuiTab-wrapper": {
          alignItems: "flex-start",
          "& .MuiTab-label .MuiTypography-caption": {
            color: r.gray[700]
          }
        },
        "& .MuiTab-labelIcon": {
          "& .MuiTab-wrapper > *:first-child": {
            marginTop: l(0.5),
            minWidth: 27,
            width: 27,
            height: 27
          }
        }
      },
      labelSizeLarge: {
        "& .MuiTab-root": {
          fontSize: "1rem"
        },
        "& .MuiTab-labelIcon *> svg": {
          minWidth: 17,
          width: 17,
          height: 17
        },
        "& .MuiBox-root button": {
          fontSize: "1rem"
        }
      },
      modeFill: {},
      modeLine: {}
    }
  );
});
function Ut(t) {
  const { alwaysVisible: n } = t, [e, i] = J(-1), r = fe(), o = Ye(() => {
    var M;
    const l = r.current;
    if (!((M = l == null ? void 0 : l.children) != null && M.length)) return;
    const d = l.offsetWidth, u = Array.from(l.children);
    u.forEach((p) => p.style.display = "inline-flex");
    const m = u[u.length - 1], S = parseInt(getComputedStyle(l).gap || "0", 10);
    let v = 0;
    for (let p = 0; p < u.length - 1; p++)
      v += u[p].offsetWidth, p !== u.length - 2 && (v += S);
    let b = v + S + m.offsetWidth;
    if (!((n ? b : v) > d)) {
      i(-1), n || (m.style.display = "none");
      return;
    }
    const B = u.slice(0, -1).findLastIndex((p) => {
      if (b -= p.offsetWidth + S, p.style.display = "none", b <= l.offsetWidth)
        return !0;
    });
    i(B);
  }, [n]), c = Ye(
    (l) => {
      r.current = (l == null ? void 0 : l.parentElement) || null, o();
    },
    [o]
  );
  return Se(() => {
    if (!r.current) return;
    const l = new ResizeObserver(() => o());
    return l.observe(r.current), () => l.disconnect();
  }, [o]), { overflowIndex: e, setDropdownRef: c };
}
const Gt = ze()((t, n) => {
  const { fixedPosition: e, hidden: i } = n;
  return {
    root: {
      "> div, > div > *": {
        height: "100%"
      },
      marginLeft: e ? "auto" : void 0,
      position: i ? "absolute" : void 0,
      visibility: i ? "hidden" : void 0
    }
  };
});
function qt(t) {
  const { label: n = window.jQuery ? $.__("More") : "More", fixedItems: e, fixedPosition: i, hidden: r, onSelect: o, size: c, tabs: l } = t, [d, u] = J(!1), { classes: m } = Gt({ fixedPosition: i, hidden: r }), { overflowIndex: S, setDropdownRef: v } = Ut({ alwaysVisible: !!(e != null && e.length) }), b = S === -1 ? [] : qe.toArray(l).slice(S), { value: k } = Je(He), B = [], M = b.map((p, C) => {
    var W;
    if (Ae(p) && (p != null && p.props)) {
      const { disabled: D, href: j, label: F, icon: H, value: P } = p.props, O = {
        text: Pe(F) || "",
        ...H ? { icon: dt(H, c) } : {},
        href: j,
        id: ((W = String(P)) == null ? void 0 : W.replace(" ", "-")) || C,
        key: P || C,
        value: P || C,
        isDisabled: D || !1,
        ...p.props.overflowProps
      };
      return P === k && B.push(O), O;
    }
    return {};
  }).concat(e || []);
  return /* @__PURE__ */ f.jsx("div", { className: m.root, ref: v, children: /* @__PURE__ */ f.jsx(
    Mt,
    {
      canQuickSelect: !0,
      isOpen: d,
      items: M,
      onClose: () => u(!1),
      onOpen: () => u(!0),
      onSelect: (p) => o(p.value),
      placement: { align: "end", side: "bottom" },
      renderToggle: (p, { onClick: C, ...W }) => /* @__PURE__ */ f.jsx(
        ut,
        {
          ...W,
          isDropdown: !0,
          label: n,
          onClick: (D) => {
            C == null || C(D), u((j) => !!j);
          }
        }
      ),
      selectedItems: B
    }
  ) });
}
const Qt = ({
  ariaLabel: t = "",
  classes: n = {},
  value: e,
  variant: i = "scrollable",
  onChange: r,
  size: o = "small",
  labelSize: c = "standard",
  scrollButtons: l = !0,
  dark: d = !1,
  onChangeOverflowIndex: u,
  children: m,
  overflowTabsDropdown: S = !1,
  dropdownLabel: v = window.jQuery ? $.__("More") : "More",
  fixedDropdownItems: b,
  fixedDropdownPosition: k = !1
}) => {
  const B = (g, z, R = !1) => {
    K(R), r(z, g);
  }, M = {
    disableRipple: !0
  }, p = o === "medium" || o === "large", { classes: C, cx: W } = ft(void 0, { props: { classes: n } }), {
    contained: D,
    darkContained: j,
    darkStandard: F,
    labelSizeLarge: H,
    modeFill: P,
    modeLine: G,
    root: O,
    rootWithDropdown: h,
    rootWithFixedDropdown: V,
    rootContained: I,
    sizeCompact: N,
    sizeLarge: ee,
    standard: ie,
    ...le
  } = C, [te, oe] = J(void 0), [q, K] = J(!1), Re = Array.isArray(m) ? m == null ? void 0 : m.slice(0, te) : [], ae = te && Array.isArray(m) ? m == null ? void 0 : m.slice(te) : [], ve = fe(null), Te = fe(null), A = fe(), Z = fe(), [se, Le] = J(0), [ce, Ee] = J([]), [me, $e] = J(0), [be, de] = J(!1), he = S && !ye.isEmpty(ae) || !ye.isEmpty(b), X = ye.debounce(() => de(!0), 100);
  return Vt("resize", X), Se(() => {
    var g, z, R, Y;
    A.current = (g = Te.current) == null ? void 0 : g.querySelector(".MuiTabs-flexContainer"), Z.current = (z = A.current) == null ? void 0 : z.cloneNode(!0), Z.current.style.visibility = "hidden", Z.current.style.position = "absolute", (Y = (R = A.current) == null ? void 0 : R.parentElement) == null || Y.appendChild(Z.current);
  }, []), Se(() => {
    var z;
    const g = Z.current;
    if (S && g && (z = g == null ? void 0 : g.children) != null && z.length) {
      const R = () => {
        var Y, re;
        Ee((Y = Array.from(g.children)) == null ? void 0 : Y.map((Q) => Q == null ? void 0 : Q.scrollWidth)), $e(parseInt((re = window.getComputedStyle(g)) == null ? void 0 : re.gap, 10) || 0), Le(g.scrollWidth ?? 1 / 0), de(!0);
      };
      R(), document.fonts.ready.then(() => R()).catch(console.error);
    }
  }, [S]), Se(() => {
    var g;
    if (S && be && se && ce) {
      const z = _t(
        ((g = A == null ? void 0 : A.current) == null ? void 0 : g.offsetWidth) || 0,
        se,
        ce,
        me
      );
      oe(z), de(!1), u == null || u(z);
    }
  }, [
    u,
    S,
    de,
    be,
    me,
    ce,
    se
  ]), /* @__PURE__ */ f.jsxs(
    ct,
    {
      "aria-label": t,
      classes: le,
      className: W({
        [O]: !0,
        [h]: he,
        [V]: k,
        [ee]: o === "large",
        [I]: p,
        [ie]: i === "standard",
        [H]: c === "large" || o === "medium" || o === "large",
        [D]: p,
        [j]: d && p,
        [F]: d && !p,
        [N]: o === "compact"
      }),
      onChange: B,
      ref: Te,
      scrollButtons: l,
      selectionFollowsFocus: !1,
      TabScrollButtonProps: M,
      value: q ? !1 : e,
      variant: i,
      children: [
        l ? m : Re,
        /* @__PURE__ */ f.jsx("div", { ref: ve, style: { padding: "0 7px 0 20px", visibility: he ? void 0 : "hidden" }, children: /* @__PURE__ */ f.jsx(
          wt,
          {
            ButtonProps: {
              color: "secondary",
              size: "small"
            },
            items: [
              ...ae == null ? void 0 : ae.map((g, z) => {
                var R;
                if (Ae(g) && (g != null && g.props)) {
                  const { disabled: Y, label: re, icon: Q, value: ge } = g.props;
                  return {
                    text: Pe(re) || "",
                    ...Q ? { icon: Q } : {},
                    id: ((R = String(ge)) == null ? void 0 : R.replace(" ", "-")) || z,
                    key: ge || z,
                    value: ge || z,
                    isDisabled: Y || !1
                  };
                }
                return {};
              }),
              ...b && !ye.isEmpty(b) ? [...b] : []
            ],
            onSelect: (g) => B(null, g, !0),
            type: "text",
            children: v
          }
        ) })
      ]
    }
  );
}, Io = (t) => {
  const {
    ariaLabel: n = "",
    classes: e = {},
    // `value` type comes from MUI as `any`
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    value: i,
    onChange: r,
    dark: o = !1,
    children: c,
    dropdownLabel: l = window.jQuery ? $.__("More") : "More",
    fixedDropdownItems: d,
    fixedDropdownPosition: u = !1,
    mode: m = "line"
  } = t, { classes: S, cx: v } = ft(void 0, { props: { classes: e } });
  let { size: b = "medium", variant: k = "standard" } = t;
  ["medium", "large"].includes(b) || (b = "medium"), k === "scrollable" && (k = "standard");
  const { modeFill: B, modeLine: M, root: p, sizeLarge: C } = S, [W, D] = J(!1), j = (F, H, P = !1) => {
    D(P), r(H, F);
  };
  return we.ifFeature(
    "encore",
    /* @__PURE__ */ f.jsx(He.Provider, { value: { dark: o && m === "fill", fixedDropdownPosition: u, mode: m, size: b, value: i }, children: /* @__PURE__ */ f.jsxs(
      ct,
      {
        "aria-label": n,
        className: v(p, {
          [B]: m === "fill",
          [M]: m === "line",
          [C]: b === "large"
        }),
        "data-fabric-component": "Tabs",
        onChange: j,
        scrollButtons: !1,
        selectionFollowsFocus: !1,
        value: W ? !1 : i,
        variant: k,
        children: [
          c,
          /* @__PURE__ */ f.jsx(
            qt,
            {
              fixedItems: d,
              fixedPosition: u,
              label: l,
              onSelect: (F) => j(null, F, !0),
              size: b,
              tabs: c
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ f.jsx(Qt, { ...t })
  );
};
export {
  Mo as T,
  Co as a,
  Io as b
};
//# sourceMappingURL=tabs-oG3vup3A.mjs.map
